import Axios from "axios";

import {
  SET_ACCOUNT_HEAD_LIST,
  UNSET_ACCOUNT_HEAD_LIST,

  SET_NON_CASH_ACCOUNT_HEAD_LIST,
  UNSET_NON_CASH_ACCOUNT_HEAD_LIST,

  SET_CASH_ACCOUNT_HEAD_LIST,
  UNSET_CASH_ACCOUNT_HEAD_LIST,

  SET_PAYMENT_ACCOUNT_HEAD_LIST,
  UNSET_PAYMENT_ACCOUNT_HEAD_LIST,
  
  SET_ALL_ACCOUNT_HEAD_LIST,
  UNSET_ALL_ACCOUNT_HEAD_LIST,

} from "@/store/mutation-types";
import { saveUpdateAccountHead, getAccountHeadList, getAllAccountHeadList, getAccountHeadById , getNonCashAccoutHeadList,getCashAccountHeadList, getPaymentAccountHeadList } from "@/store/api";
// initial state
const state = {
  getAccountHeadList: [],
  getNonCashAccoutHeadList: [],
  getPaymentAccountHeadList: [],
  getCashAccountHeadList: [],
  getAllAccountHeadList: [],
};

const getters = {
  getAccountHeadList(state) {
    return state.getAccountHeadList;
  },
  getNonCashAccoutHeadList(state){
    return state.getNonCashAccoutHeadList;
  },
  getPaymentAccountHeadList(state){
    return state.getPaymentAccountHeadList;
  },
  getCashAccountHeadList(state){
    return state.getCashAccountHeadList;
  },
  getAllAccountHeadList(state) {
    return state.getAllAccountHeadList;
  },
};
const mutations = {
  [SET_ACCOUNT_HEAD_LIST](state, data) {
    state.getAccountHeadList = data;
  },
  [UNSET_ACCOUNT_HEAD_LIST](state) {
    state.getAccountHeadList = [];
  },

  [SET_NON_CASH_ACCOUNT_HEAD_LIST](state, data){
    state.getNonCashAccoutHeadList = data;
  },
  [UNSET_NON_CASH_ACCOUNT_HEAD_LIST](state){
    state.getNonCashAccoutHeadList = []
  },

  [SET_CASH_ACCOUNT_HEAD_LIST](state, data){
    state.getCashAccountHeadList = data;
  },
  [UNSET_CASH_ACCOUNT_HEAD_LIST](state, data){
    state.getCashAccountHeadList = [];
  },

  [SET_PAYMENT_ACCOUNT_HEAD_LIST](state,data){
    state.getPaymentAccountHeadList = data;
  },
  [UNSET_PAYMENT_ACCOUNT_HEAD_LIST](state, data){
    state.getPaymentAccountHeadList = [];
  },

  [SET_ALL_ACCOUNT_HEAD_LIST](state, data) {
    state.getAllAccountHeadList = data;
  },
  [UNSET_ALL_ACCOUNT_HEAD_LIST](state) {
    state.getAllAccountHeadList = [];
  },


};

const actions = {

  saveUpdateAccountHead({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      // console.log(data);
      Axios.post(saveUpdateAccountHead, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getAccountHeadList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getAccountHeadList, {params: data})
        .then(function (response) {
          commit('SET_ACCOUNT_HEAD_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_ACCOUNT_HEAD_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getAllAccountHeadList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getAllAccountHeadList)
        .then(function (response) {
          commit('SET_ALL_ACCOUNT_HEAD_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_ALL_ACCOUNT_HEAD_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getAccountHeadById({ commit }, id) {
    return new Promise((resolve, reject) => {
      Axios.get(getAccountHeadById + "/" + id)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  //Non cash accounts
  getNonCashAccoutHeadList({commit} ) {
    return new Promise((resolve, reject) => {
      Axios.get(getNonCashAccoutHeadList)
        .then(function (response) {
          commit('SET_NON_CASH_ACCOUNT_HEAD_LIST', response.data.data)
          // console.log(response.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_NON_CASH_ACCOUNT_HEAD_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  //Cash accounts 
  getCashAccountHeadList({commit}){
    return new Promise((resolve, reject) => {
      Axios.get(getCashAccountHeadList)
        .then(function (response) {
          commit('SET_CASH_ACCOUNT_HEAD_LIST', response.data.data)
          // console.log(response.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_CASH_ACCOUNT_HEAD_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  //Payment account head
  getPaymentAccountHeadList({commit}, data){
    return new Promise((resolve, reject) => {
      Axios.get(`${getPaymentAccountHeadList}?payment_method=${data.type}`)
        .then(function (response) {
          commit('SET_PAYMENT_ACCOUNT_HEAD_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_PAYMENT_ACCOUNT_HEAD_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  }

};

export default {
  state,
  getters,
  actions,
  mutations,
};